<ng-container>
  <nav *ngIf="!hidden && (breadcrumbService.items$ | async) as items" class="layout-breadcrumb">

    <button *ngIf="items.length > 1" type="button" class="bc-back" (click)="goBack(items)">
      <lucide-icon name="arrow-left" [size]="14"></lucide-icon>
    </button>

    <ol class="bc-list">
      <ng-container *ngFor="let item of items; let last = last">

        <li class="bc-item" [class.bc-item--current]="last">
          <!-- Parent items — clickable -->
          <ng-container *ngIf="!last">
            <a *ngIf="item.url" class="bc-link" [routerLink]="item.url" queryParamsHandling="preserve">
              {{ item.isKey ? (item.label | translate) : item.label }}
            </a>
            <button *ngIf="!item.url && item.action" type="button" class="bc-link" (click)="item.action!()">
              {{ item.isKey ? (item.label | translate) : item.label }}
            </button>
            <span *ngIf="!item.url && !item.action">
              {{ item.isKey ? (item.label | translate) : item.label }}
            </span>
          </ng-container>

          <!-- Current (last) item — not clickable -->
          <span *ngIf="last">
            {{ item.isKey ? (item.label | translate) : item.label }}
          </span>
        </li>

        <li *ngIf="!last" class="bc-sep" aria-hidden="true"> / </li>

      </ng-container>
    </ol>

  </nav>

  <h1
    *ngIf="!hidden && (breadcrumbService.pageTitle$ | async) as pt"
    class="page-title"
  >{{ pt.isKey ? (pt.label | translate) : pt.label }}</h1>

</ng-container>
